import { render, staticRenderFns } from "./pinBadge.vue?vue&type=template&id=47c03167&scoped=true"
import script from "./pinBadge.vue?vue&type=script&lang=js"
export * from "./pinBadge.vue?vue&type=script&lang=js"
import style0 from "./pinBadge.vue?vue&type=style&index=0&id=47c03167&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c03167",
  null
  
)

export default component.exports